import { Stack } from '@mui/material';
import { PerformersCard, PerformersCardProps } from './PerformersCard';
import { RslReport } from '../../api/schema';
import { AIInsights } from '@features/ai-insights';
import { ComparisonByDimensionCard } from './ComparisonByDimension/ComparisonByDimensionCard';

type RealTimeOptimizationProps = {
  report: RslReport;
  reports: PerformersCardProps['reports'];
  campaignName: string;
  aiInsights: AIInsights | null;
};

export const RealTimeOptimization = (props: RealTimeOptimizationProps) => {
  return (
    <Stack direction="column" gap="1rem">
      <PerformersCard
        dimensions={props.report.dimensions}
        reports={props.reports}
        aiInsights={props.aiInsights}
      />
      <ComparisonByDimensionCard
        key={props.report.id}
        report={props.report}
        campaignName={props.campaignName}
      />
    </Stack>
  );
};
